export const ITEM_CONSUMPTION_REPORT_GO_BUTTON_API = 'ITEM_CONSUMPTION_REPORT_GO_BUTTON_API'
export const ITEM_CONSUMPTION_REPORT_GO_BUTTON_API_SUCCESS = 'ITEM_CONSUMPTION_REPORT_GO_BUTTON_API_SUCCESS'


export const ITEM_CONSUMPTION_REPORT_API_ERROR_ACTION = 'ITEM_CONSUMPTION_REPORT_API_ERROR_ACTION'